// components/ui/Breadcrumb.tsx
import { ChevronRight, Home } from 'lucide-react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  showHome?: boolean;
  className?: string;
}

export function Breadcrumb({ items, showHome = false, className }: BreadcrumbProps) {
  const allItems: BreadcrumbItem[] = showHome
    ? [{ label: 'Home', href: '/' }, ...items]
    : items;

  return (
    <nav className={cn('flex items-center text-sm', className)} aria-label="Breadcrumb">
      <ol className="flex items-center gap-1">
        {allItems.map((item, index) => {
          const isLast = index === allItems.length - 1;

          return (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <ChevronRight size={14} className="mx-1 text-gray-400" />
              )}
              {item.href && !isLast ? (
                <Link
                  to={item.href}
                  className="text-gray-500 hover:text-gray-700 transition-colors flex items-center gap-1"
                >
                  {index === 0 && showHome && <Home size={14} />}
                  {item.label}
                </Link>
              ) : (
                <span className={cn(
                  'flex items-center gap-1',
                  isLast ? 'text-gray-900 font-medium' : 'text-gray-500'
                )}>
                  {index === 0 && showHome && <Home size={14} />}
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
